// LivestreamUserTriggerModals.js
'use strict';
import { connect } from 'react-redux';

import LivestreamUserTriggerModals from '../component/LivestreamUserTriggerModals.jsx';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getGoalData from '../selector/getGoalData.js';
import {
  ExclusivePrivateStatus,
  PRESET_SD,
} from '../resource/liveStreamConstants.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { TRIGGER_EXCLUSIVE_HOLDINGTIME } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const currentGoalId = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'currentId'
  );

  return {
    timestampOffsetSeconds: getTimestampOffset(state, Accuracy.SECOND),
    privateStreamPrice: getLiveStreamData(
      state,
      [streamId, 'pricing'],
      PRESET_SD
    ),
    exclusivePrivatePrice: getLiveStreamData(
      state,
      [streamId, 'settings'],
      'exclusivePrice'
    ),
    countdownToPrivateExp:
      getLiveStreamData(state, [streamId, 'presets', PRESET_SD], 'nbf') ||
      getLiveStreamData(
        state,
        [streamId, 'presets', PRESET_SD, 'counter'],
        'exp'
      ),
    countdownToExclusivePrivateNbf: getGoalData(state, [currentGoalId], 'nbf'),
    streamerId: streamId,
    meId: getMeData(state, 'id'),
    isExclusivePrivatePreparing:
      exclusivePrivateStatus === ExclusivePrivateStatus.PREPARING,
    triggerExclusiveHoldingtime: getRemoteConfigData(
      state,
      TRIGGER_EXCLUSIVE_HOLDINGTIME
    ),
  };
};

export default connect(mapStateToProps, null)(LivestreamUserTriggerModals);
